module.exports = __webpack_public_path__ + "img/pic_310736_3.6e193268.jpg";